/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./takeaway-loader";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
import * as i4 from "../../../globals";
import * as i5 from "ionic-angular/components/loading/loading-controller";
import * as i6 from "../../configuration/services";
import * as i7 from "../services";
var styles_TakeawayLoaderPage = [];
var RenderType_TakeawayLoaderPage = i0.ɵcrt({ encapsulation: 2, styles: styles_TakeawayLoaderPage, data: {} });
export { RenderType_TakeawayLoaderPage as RenderType_TakeawayLoaderPage };
export function View_TakeawayLoaderPage_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_TakeawayLoaderPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-takeaway-loader", [], null, null, null, View_TakeawayLoaderPage_0, RenderType_TakeawayLoaderPage)), i0.ɵdid(1, 49152, null, 0, i1.TakeawayLoaderPage, [i2.NavController, i3.NavParams, i4.Globals, i5.LoadingController, i6.ConfigurationServices, i7.TakeawayServices], null, null)], null, null); }
var TakeawayLoaderPageNgFactory = i0.ɵccf("page-takeaway-loader", i1.TakeawayLoaderPage, View_TakeawayLoaderPage_Host_0, {}, {}, []);
export { TakeawayLoaderPageNgFactory as TakeawayLoaderPageNgFactory };
//# sourceMappingURL=takeaway-loader.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/takeaway/takeaway-loader/takeaway-loader.ngfactory.js
// module id = null
// module chunks = 